import type { ProductSettings } from "@wbly/data-storefront";
import { replaceText } from "@wbly/common";
import type { Hit } from "instantsearch.js";
import type { Marketplace } from "@wbly/client";
import type { AlgoliaProduct } from "../../types/algolia-product";
import { getProductUrl } from "../../util/get-product-url";
import type { ProductCardProps } from "../ProductCard";

export function formatAgeRange(
  productSettings: ProductSettings,
  min: string,
  max: string
) {
  if (!max) {
    return replaceText(productSettings.ageMinLabel, { min });
  }
  return replaceText(productSettings.ageRangeLabel, { min, max });
}

export function formatPrice(productSettings: ProductSettings, price: string) {
  return replaceText(productSettings.priceFromLabel, { price });
}

export function formatAlgoliaHit(
  marketplace: Marketplace,
  productSettings: ProductSettings,
  hit: Hit
): ProductCardProps & { image: string; ageRange: string } & {
  objectID: string;
  position: number;
  queryID: string;
} {
  return {
    title: hit.title,
    description: hit.productBadgeContent,
    href: getProductUrl(marketplace, hit as Hit<AlgoliaProduct>),
    image: hit.imageURL,
    price: formatPrice(productSettings, hit.price),
    ageRange: formatAgeRange(productSettings, hit.minimumAge, hit.maximumAge),
    objectID: hit.objectID,
    position: hit.__position,
    queryID: hit.__queryID,
  };
}
